<apx-chart
  *ngIf="isTimeSeries ? true : (chartDef.data | json) !== '{}'; else noData"
  class="flex-auto w-full h-full"
  [chart]="chartOptions.chart"
  [dataLabels]="chartOptions.dataLabels"
  [plotOptions]="chartOptions.plotOptions"
  [series]="chartOptions.series"
  [tooltip]="chartOptions.tooltip"
  [xaxis]="chartOptions.xaxis"
  [yaxis]="chartOptions.yaxis"
  [colors]="chartOptions.colors"
></apx-chart>
<ng-template #noData>
  <p class="font-bold text-md text-secondary uppercase tracking-wider text-center p-4">
    Insufficient data to display graph
  </p>
</ng-template>
